export default __webpack_public_path__ + "static/media/00.ce8d7563.jpg";